module.exports = __webpack_public_path__ + "img/email.a6dfa3bc.svg";